export default "__VITE_ASSET__DEwZpTJW__"